import { render, staticRenderFns } from "./ApprovePrintingBtn.vue?vue&type=template&id=1c7405c1&scoped=true&"
import script from "./ApprovePrintingBtn.vue?vue&type=script&lang=js&"
export * from "./ApprovePrintingBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7405c1",
  null
  
)

export default component.exports